// extracted by mini-css-extract-plugin
export default {"wrapper":"HeadroomAffix__wrapper___TvJYi","pin":"HeadroomAffix__pin___R5TS0","unfixed":"HeadroomAffix__unfixed___bjSd6","transformWrapper":"HeadroomAffix__transformWrapper___slISx"};